export const ROOT_ID = 0;
export const MAX_FOLDER_NAME_CHARS = 50;
export const MAX_FOLDER_NESTING_LEVEL = 3;

export default {
  BLANK_PAGE_TEMPLATE_ID: 'blank',
  SHOP_PAGE_TEMPLATE_ID: 'shop',
  ACTIVE_PAGE_KEY: 'active-page',
};
